import { Directory } from "../../../../../../base/domain/drawing";
import { TimeMeasure } from "../../../../../../base/utilities";
import { ITreeSource } from ".";
import { DomainRegistry } from "../../../../../domain";
import { EditableFormatSummary } from "../../../../../domain/editableFormat";

export class FormatTreeSource implements ITreeSource<number, EditableFormatSummary> {
  entityName: string = "フォーマット情報";

  getTree(): Promise<Directory<number, EditableFormatSummary>[]> {
    return TimeMeasure.logAsync(
      "Tree取得",
      async () => {
        const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
        return repository.getFormatTree();
      },
      "",
      TimeMeasure.debug
    );
  }
}
